import parse from 'html-react-parser';
import * as DOMPurify from 'dompurify';
export const htmlFromString = (htmlString, options) => {
    const cleanHtmlString = DOMPurify.sanitize(htmlString, {
        USE_PROFILES: { html: true },
        // NAMESPACE: namespace,
    });
    const html = parse(cleanHtmlString, options);
    return html;
};
